import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { env } from '../../../env/env';
import { LogoutService } from './logout.service';
import { StorageService } from './storage.service';
import { ToastMessageService } from '@shared/services/toast-message.service';
import { jsonToFormData } from '../helpers/formData';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private http = inject(HttpClient);
  private _logoutService = inject(LogoutService);
  private storage = inject(StorageService);
  private _toastMessageService = inject(ToastMessageService);

  private baseUrl: string = env.url;

  public login(data: any) {
    return this.http.post(`${this.baseUrl}account/login`, jsonToFormData(data));
  }


  hasPermission(url: string): boolean {
    const permissions = this.storage.userPermissions;

    // Most-specific routes first so detail pages aren't shadowed by their list route.
    if (url.startsWith("/invoice/invoice-details")) {
      return !!permissions?.invoices?.invoice_page?.view?.value;
    } else if (url.startsWith("/invoice")) {
      return !!permissions?.invoices?.invoices_list?.view?.value;
    }

    else if (url.startsWith("/related-company")) {
      return !!permissions?.relatedCompany?.relatedCompany_list?.view?.value;
    }

    else if (url.startsWith("/products/product-details")) {
      return !!permissions?.products?.product_page?.view?.value;
    } else if (url.startsWith("/products")) {
      return !!permissions?.products?.products_list?.view?.value;
    }

    else if (url.startsWith("/roles/assign-permissions")) {
      return !!permissions?.roles?.roles_list?.assign?.value;
    } else if (url.startsWith("/roles/role-details")) {
      return !!permissions?.roles?.role_page?.view?.value;
    } else if (url.startsWith("/roles")) {
      return !!permissions?.roles?.roles_list?.view?.value;
    }

    else if (url.startsWith("/users/user-details")) {
      return !!permissions?.users?.user_page?.view?.value;
    } else if (url.startsWith("/users")) {
      return !!permissions?.users?.users_list?.view?.value;
    }

    else if (url.startsWith("/download-invoices")) {
      return !!permissions?.invoices?.download_ZIP_Invoices?.view?.value;
    }

    // Default deny unknown routes.
    return false;
  }

  goToTargetPath() {
    const permissions = this.storage.userPermissions;
    if (permissions?.invoices?.invoices_list?.view?.value) {
      return "/invoice";
    } else if (permissions?.relatedCompany?.relatedCompany_list?.view?.value) {
      return "/related-company";
    } else if (permissions?.products?.products_list?.view?.value) {
      return "/products";
    } else if (permissions?.roles?.roles_list?.view?.value) {
      return "/roles";
    } else if (permissions?.users?.users_list?.view?.value) {
      return "/users";
    } else if (permissions?.invoices?.download_ZIP_Invoices?.view?.value) {
      return "/download-invoices";
    }

    this._toastMessageService.toastOnError('error', "You don't have access to the system");
    this._logoutService.logout();
    return '';
  }


}
